import { render, staticRenderFns } from "./PricesTable.vue?vue&type=template&id=f241bff4"
import script from "./PricesTable.vue?vue&type=script&lang=js"
export * from "./PricesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports